import React, { useEffect, useState } from 'react';
import { getPolicyPdfUrl } from './services/firebase';

const PolicyPDF = () => {
    const [pdfUrl, setPdfUrl] = useState('');

    useEffect(() => {
        let active = true;
        getPolicyPdfUrl()
            .then((url) => { if (active) setPdfUrl(url); })
            .catch((err) => console.error('Failed to load policy PDF', err));
        return () => { active = false; };
    }, []);

    return (
        <div>
            {pdfUrl && (
                <iframe src={pdfUrl} title="Warehouse Policy" width="100%" height={getCurrentDimension().height} />
            )}
        </div>
    );
};
export default PolicyPDF;
function getCurrentDimension(){
    return {
        width: window.innerWidth,
      	height: window.innerHeight
    }
}
